// import React from "react";
// import {
//   Container,
//   Typography,
//   Box,
//   useTheme,
//   alpha,
//   Grid,
//   Paper,
//   Card,
//   CardContent,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Divider,
//   Chip,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
// } from "@mui/material";
// import PriceChangeIcon from "@mui/icons-material/PriceChange";
// import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
// import TrendingUpIcon from "@mui/icons-material/TrendingUp";
// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import LocationCityIcon from "@mui/icons-material/LocationCity";
// import HomeIcon from "@mui/icons-material/Home";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// // import FeatureLayout from "./FeatureLayout";
// import FeatureLayout from "./FeatureLayout";

// // App screenshot placeholders (replace with actual screenshots)
// import pricingScreenshot1 from "../../../images/features/set-price-1.png";
// import pricingScreenshot2 from "../../../images/features/set-price-1.png";
// import pricingScreenshot3 from "../../../images/features/set-price-2.png"

// // const placeholderImage = "https://placehold.co/800x600/667eea/white?text=App+Screenshot";

// const SetYourPrice = () => {
//   const theme = useTheme();

//   const benefits = [
//     {
//       icon: <AttachMoneyIcon />,
//       title: "Maximize Your Revenue",
//       description: "Charge premium rates during peak season, holidays, and local events. Adjust pricing based on demand.",
//     },
//     {
//       icon: <TrendingUpIcon />,
//       title: "Keep Healthy Margins",
//       description: "Set cleaning fees that work for your business model. No forced pricing from the platform.",
//     },
//     {
//       icon: <CalendarTodayIcon />,
//       title: "Seasonal Flexibility",
//       description: "Easily adjust prices for high and low seasons. Increase during summer, decrease in winter.",
//     },
//     {
//       icon: <LocationCityIcon />,
//       title: "Market-Based Pricing",
//       description: "Set different rates for different neighborhoods and property types. Know your local market.",
//     },
//     {
//       icon: <HomeIcon />,
//       title: "Property-Specific Rates",
//       description: "Charge different prices for studios vs. luxury villas. Each property has unique needs.",
//     },
//     {
//       icon: <PriceChangeIcon />,
//       title: "Transparent Guest Pricing",
//       description: "Guests see the exact cleaning fee upfront. No hidden surprises or platform markups.",
//     },
//   ];

//   const stats = [
//     { value: "40%", label: "Revenue increase potential" },
//     { value: "0%", label: "Platform markup" },
//     { value: "100%", label: "Pricing control" },
//     { value: "3x", label: "ROI for hosts" },
//   ];

//   const pricingExamples = [
//     { property: "Studio Apartment", standard: "$45", peak: "$65", holiday: "$75", margin: "$20-30" },
//     { property: "1-Bedroom", standard: "$65", peak: "$85", holiday: "$95", margin: "$25-35" },
//     { property: "2-Bedroom", standard: "$85", peak: "$110", holiday: "$125", margin: "$30-45" },
//     { property: "3-Bedroom House", standard: "$120", peak: "$160", holiday: "$180", margin: "$40-60" },
//     { property: "Luxury Villa", standard: "$180", peak: "$250", holiday: "$300", margin: "$60-80" },
//   ];

//   return (
//     <FeatureLayout
//       title="Set Your Own Cleaning Fee"
//       subtitle="You're in complete control of your pricing strategy"
//       description="Stop letting platforms dictate your cleaning fees. With FreshSweeper, you decide what to charge guests. Set different rates by property, season, or demand. Keep 100% of the cleaning fee above your cleaner's rate."
//       icon={<PriceChangeIcon sx={{ fontSize: 32 }} />}
//       iconGradient="linear-gradient(135deg, #43e97b, #38f9d7)"
//       breadcrumbs={[
//         { label: "Features", link: "/features" },
//         { label: "Set Your Own Price" },
//       ]}
//       benefits={benefits}
//       stats={stats}
//       imageRight={pricingScreenshot1}
//       imageLeft={pricingScreenshot2}
//     >
//       {/* Pricing Strategy Section */}
//       <Container maxWidth="lg" sx={{ py: 6 }}>
//         <Typography
//           variant="h3"
//           sx={{
//             fontWeight: 800,
//             mb: 4,
//             textAlign: "center",
//             fontSize: { xs: "1.8rem", md: "2.5rem" },
//           }}
//         >
//           How Much More Could You Earn?
//         </Typography>
        
//         <Paper
//           elevation={0}
//           sx={{
//             borderRadius: 4,
//             overflow: "hidden",
//             border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//             mb: 4,
//           }}
//         >
//           <Box sx={{ p: 3, bgcolor: alpha(theme.palette.primary.main, 0.02), borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
//             <Typography variant="h6" fontWeight="800">Estimated Earnings by Property Type</Typography>
//             <Typography variant="body2" color="text.secondary">Based on 20 cleanings per month</Typography>
//           </Box>
//           <Box sx={{ overflowX: "auto" }}>
//             <Table>
//               <TableHead>
//                 <TableRow sx={{ bgcolor: alpha(theme.palette.primary.main, 0.05) }}>
//                   <TableCell sx={{ fontWeight: 800 }}>Property Type</TableCell>
//                   <TableCell sx={{ fontWeight: 800 }}>Standard Fee</TableCell>
//                   <TableCell sx={{ fontWeight: 800 }}>Peak Season</TableCell>
//                   <TableCell sx={{ fontWeight: 800 }}>Holiday Rate</TableCell>
//                   <TableCell sx={{ fontWeight: 800 }}>Your Margin</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {pricingExamples.map((example, idx) => (
//                   <TableRow key={idx}>
//                     <TableCell sx={{ fontWeight: 600 }}>{example.property}</TableCell>
//                     <TableCell>{example.standard}</TableCell>
//                     <TableCell sx={{ color: theme.palette.warning.main, fontWeight: 600 }}>{example.peak}</TableCell>
//                     <TableCell sx={{ color: theme.palette.error.main, fontWeight: 600 }}>{example.holiday}</TableCell>
//                     <TableCell sx={{ color: theme.palette.success.main, fontWeight: 700 }}>{example.margin}</TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </Box>
//           <Box sx={{ p: 3, bgcolor: alpha(theme.palette.success.main, 0.05) }}>
//             <Typography variant="caption" color="success.main" fontWeight="600">
//               💡 With 5 properties, strategic pricing could add $1,000-2,500+ to your monthly revenue
//             </Typography>
//           </Box>
//         </Paper>
//       </Container>

//       {/* Flexibility Section */}
//       <Container maxWidth="lg" sx={{ py: 6 }}>
//         <Grid container spacing={6} alignItems="center">
//           <Grid item xs={12} md={6}>
//             <Typography variant="h4" fontWeight="800" gutterBottom>
//               Dynamic Pricing at Your Fingertips
//             </Typography>
//             <Typography variant="body1" sx={{ mb: 3, color: "text.secondary" }}>
//               Adjust cleaning fees in real-time based on demand, seasonality, and special events. 
//               Our flexible system lets you respond to market conditions instantly.
//             </Typography>
//             <List>
//               {[
//                 "Set higher rates for holiday weekends and peak season",
//                 "Offer competitive pricing for longer stays",
//                 "Adjust prices based on local events and conferences",
//                 "Create custom pricing rules for specific properties",
//               ].map((text, idx) => (
//                 <ListItem key={idx}>
//                   <ListItemIcon>
//                     <CheckCircleIcon sx={{ color: theme.palette.success.main }} />
//                   </ListItemIcon>
//                   <ListItemText primary={text} />
//                 </ListItem>
//               ))}
//             </List>
//           </Grid>
//           <Grid item xs={12} md={6}>
//             <Box
//               component="img"
//               src={pricingScreenshot3}
//               alt="Dynamic pricing dashboard"
//               sx={{
//                 width: "100%",
//                 borderRadius: 4,
//                 boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
//               }}
//             />
//           </Grid>
//         </Grid>
//       </Container>

//       {/* Transparent Pricing */}
//       <Container maxWidth="lg" sx={{ py: 6 }}>
//         <Paper
//           elevation={0}
//           sx={{
//             p: 4,
//             borderRadius: 4,
//             background: `linear-gradient(135deg, ${alpha(theme.palette.info.main, 0.05)} 0%, ${alpha(theme.palette.info.dark, 0.02)} 100%)`,
//             border: `1px solid ${alpha(theme.palette.info.main, 0.2)}`,
//             textAlign: "center",
//           }}
//         >
//           <Typography variant="h5" fontWeight="800" gutterBottom>
//             No Hidden Fees. Total Transparency.
//           </Typography>
//           <Typography variant="body1" sx={{ mb: 3, maxWidth: "600px", mx: "auto" }}>
//             What you set is what guests pay. We don't add surprise markups or hidden platform fees.
//           </Typography>
//           <Grid container spacing={3} sx={{ maxWidth: 800, mx: "auto" }}>
//             <Grid item xs={4}>
//               <Typography variant="h4" fontWeight="800" color="success.main">0%</Typography>
//               <Typography variant="caption">Hidden Markup</Typography>
//             </Grid>
//             <Grid item xs={4}>
//               <Typography variant="h4" fontWeight="800" color="success.main">100%</Typography>
//               <Typography variant="caption">You Control</Typography>
//             </Grid>
//             <Grid item xs={4}>
//               <Typography variant="h4" fontWeight="800" color="success.main">5%</Typography>
//               <Typography variant="caption">Platform Fee*</Typography>
//             </Grid>
//           </Grid>
//           <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: "block" }}>
//             * Only charged on completed bookings. No monthly fees or minimums.
//           </Typography>
//         </Paper>
//       </Container>
//     </FeatureLayout>
//   );
// };

// export default SetYourPrice;


import React from "react";
import {
  Container,
  Typography,
  Box,
  useTheme,
  alpha,
  Grid,
  Paper,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import HomeIcon from "@mui/icons-material/Home";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PaidIcon from "@mui/icons-material/Paid";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import FeatureLayout from "./FeatureLayout";

// App screenshot placeholders
import pricingScreenshot1 from "../../../images/features/set-price-1.png";
import pricingScreenshot2 from "../../../images/features/set-price-4.png";
import pricingScreenshot3 from "../../../images/features/set-price-2.png";

const SetYourPrice = () => {
  const theme = useTheme();

  const benefits = [
    {
      icon: <PaidIcon />,
      title: "Fair Cleaner Compensation",
      description: "Set rates that respect your cleaners' hard work. Pay what they deserve for each property.",
    },
    {
      icon: <AttachMoneyIcon />,
      title: "Control Your Costs",
      description: "You decide how much to pay per cleaning. No forced pricing from the platform.",
    },
    {
      icon: <CalendarTodayIcon />,
      title: "Property-Based Rates",
      description: "Pay different rates for different properties. A studio requires less work than a 5-bedroom villa.",
    },
    {
      icon: <LocationCityIcon />,
      title: "Market-Adjusted Pay",
      description: "Adjust cleaner pay based on location, difficulty, and local market rates.",
    },
    {
      icon: <HomeIcon />,
      title: "Per-Cleaner Flexibility",
      description: "Set individual rates for each cleaner. Pay more for experienced, trusted cleaners.",
    },
    {
      icon: <PriceChangeIcon />,
      title: "Review & Adjust Anytime",
      description: "Update cleaner rates instantly. Reward great work or adjust for changing circumstances.",
    },
  ];

  const stats = [
    { value: "100%", label: "Control over cleaner pay" },
    { value: "0%", label: "Platform rate interference" },
    { value: "Per property", label: "Custom rates" },
    { value: "Per cleaner", label: "Individual rates" },
  ];

  // Updated pricing examples - Focus on cleaner pay rates
  const pricingExamples = [
    { property: "Studio Apartment", standardRate: "$45", peakRate: "$55", complexRate: "$65", cleanerEarns: "$45-65" },
    { property: "1-Bedroom", standardRate: "$55", peakRate: "$70", complexRate: "$80", cleanerEarns: "$55-80" },
    { property: "2-Bedroom", standardRate: "$75", peakRate: "$95", complexRate: "$110", cleanerEarns: "$75-110" },
    { property: "3-Bedroom House", standardRate: "$100", peakRate: "$130", complexRate: "$150", cleanerEarns: "$100-150" },
    { property: "Luxury Villa", standardRate: "$150", peakRate: "$200", complexRate: "$250", cleanerEarns: "$150-250" },
  ];

  return (
    <FeatureLayout
      title="Set Your Cleaner's Pay"
      subtitle="You decide what your cleaners earn. Full control over rates."
      description="Stop letting platforms dictate what you pay your cleaners. With FreshSweeper, you set the rates. Pay more for experienced cleaners, adjust by property difficulty, or offer bonuses for peak season. Your cleaners, your rates."
      icon={<PriceChangeIcon sx={{ fontSize: 32 }} />}
      iconGradient="linear-gradient(135deg, #43e97b, #38f9d7)"
      breadcrumbs={[
        { label: "Features", link: "/features" },
        { label: "Set Your Cleaner's Pay" },
      ]}
      benefits={benefits}
      stats={stats}
      imageRight={pricingScreenshot1}
      imageLeft={pricingScreenshot2}
    >
      {/* Cleaner Pay Strategy Section */}
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 800,
            mb: 4,
            textAlign: "center",
            fontSize: { xs: "1.8rem", md: "2.5rem" },
          }}
        >
          Pay What Your Cleaners Deserve
        </Typography>
        
        <Paper
          elevation={0}
          sx={{
            borderRadius: 4,
            overflow: "hidden",
            border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
            mb: 4,
          }}
        >
          <Box sx={{ p: 3, bgcolor: alpha(theme.palette.primary.main, 0.02), borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
            <Typography variant="h6" fontWeight="800">Sample Cleaner Pay Rates by Property</Typography>
            <Typography variant="body2" color="text.secondary">You set these rates. Adjust anytime.</Typography>
          </Box>
          <Box sx={{ overflowX: "auto" }}>
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: alpha(theme.palette.primary.main, 0.05) }}>
                  <TableCell sx={{ fontWeight: 800 }}>Property Type</TableCell>
                  <TableCell sx={{ fontWeight: 800 }}>Standard Rate</TableCell>
                  <TableCell sx={{ fontWeight: 800 }}>Peak Season</TableCell>
                  <TableCell sx={{ fontWeight: 800 }}>Complex Clean</TableCell>
                  <TableCell sx={{ fontWeight: 800 }}>Cleaner Earns</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {pricingExamples.map((example, idx) => (
                  <TableRow key={idx}>
                    <TableCell sx={{ fontWeight: 600 }}>{example.property}</TableCell>
                    <TableCell>{example.standardRate}</TableCell>
                    <TableCell sx={{ color: theme.palette.warning.main, fontWeight: 600 }}>{example.peakRate}</TableCell>
                    <TableCell sx={{ color: theme.palette.error.main, fontWeight: 600 }}>{example.complexRate}</TableCell>
                    <TableCell sx={{ color: theme.palette.success.main, fontWeight: 700 }}>{example.cleanerEarns}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
          <Box sx={{ p: 3, bgcolor: alpha(theme.palette.success.main, 0.05) }}>
            <Typography variant="caption" color="success.main" fontWeight="600">
              💡 Pro tip: Pay premium rates for your best cleaners. They'll prioritize your properties and go the extra mile.
            </Typography>
          </Box>
        </Paper>
      </Container>

      {/* Flexibility Section */}
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="h4" fontWeight="800" gutterBottom>
              Flexible Pay for Every Situation
            </Typography>
            <Typography variant="body1" sx={{ mb: 3, color: "text.secondary" }}>
              Every property is different. Every cleaner has different experience levels. 
              Our flexible rate system lets you pay exactly what makes sense.
            </Typography>
            <List>
              {[
                "Pay more for last-minute bookings or holiday cleans",
                "Offer bonuses for exceptional 5-star reviews",
                "Set higher rates for properties with special requirements",
                "Reward loyal cleaners with above-market pay",
                "Adjust rates when cleaners go above and beyond",
              ].map((text, idx) => (
                <ListItem key={idx}>
                  <ListItemIcon>
                    <CheckCircleIcon sx={{ color: theme.palette.success.main }} />
                  </ListItemIcon>
                  <ListItemText primary={text} />
                </ListItem>
              ))}
            </List>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src={pricingScreenshot3}
              alt="Rate management dashboard"
              sx={{
                width: "100%",
                borderRadius: 4,
                boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
              }}
            />
          </Grid>
        </Grid>
      </Container>

      {/* Per-Cleaner Rate Management */}
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Paper
          elevation={0}
          sx={{
            p: 4,
            borderRadius: 4,
            background: `linear-gradient(135deg, ${alpha(theme.palette.info.main, 0.05)} 0%, ${alpha(theme.palette.info.dark, 0.02)} 100%)`,
            border: `1px solid ${alpha(theme.palette.info.main, 0.2)}`,
          }}
        >
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} md={7}>
              <Typography variant="h5" fontWeight="800" gutterBottom>
                👥 Individual Cleaner Rates
              </Typography>
              <Typography variant="body1" sx={{ mb: 2, color: "text.secondary" }}>
                Pay different rates to different cleaners. Your most experienced, trusted cleaner 
                deserves more than someone you just hired.
              </Typography>
              <List dense>
                {[
                  "Set base rates per cleaner",
                  "Add performance bonuses",
                  "Offer seniority pay increases",
                  "Adjust rates without renegotiating everything",
                ].map((text, idx) => (
                  <ListItem key={idx} dense>
                    <ListItemIcon>
                      <CheckCircleIcon sx={{ color: theme.palette.success.main, fontSize: 18 }} />
                    </ListItemIcon>
                    <ListItemText primary={text} primaryTypographyProps={{ variant: "body2" }} />
                  </ListItem>
                ))}
              </List>
            </Grid>
            <Grid item xs={12} md={5}>
              <Paper
                elevation={0}
                sx={{
                  p: 2,
                  borderRadius: 2,
                  bgcolor: alpha(theme.palette.background.paper, 0.8),
                  border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                }}
              >
                <Typography variant="subtitle2" fontWeight="700" gutterBottom>Example:</Typography>
                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                  <Typography variant="body2">Maria (3 years, 5⭐ rating)</Typography>
                  <Typography variant="body2" fontWeight="700" color="success.main">$85/clean</Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                  <Typography variant="body2">James (1 year, 4.8⭐ rating)</Typography>
                  <Typography variant="body2" fontWeight="700">$70/clean</Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="body2">Lisa (New, 4.5⭐ rating)</Typography>
                  <Typography variant="body2" fontWeight="700">$60/clean</Typography>
                </Box>
                <Divider sx={{ my: 1 }} />
                <Typography variant="caption" color="text.secondary">
                  Same property, different rates based on experience
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Paper>
      </Container>

      {/* Transparent Fee Structure */}
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Paper
          elevation={0}
          sx={{
            p: 4,
            borderRadius: 4,
            background: `linear-gradient(135deg, ${alpha(theme.palette.success.main, 0.05)} 0%, ${alpha(theme.palette.success.dark, 0.02)} 100%)`,
            border: `1px solid ${alpha(theme.palette.success.main, 0.2)}`,
            textAlign: "center",
          }}
        >
          <Typography variant="h5" fontWeight="800" gutterBottom>
            💰 Keep Your Margins. Pay Cleaners Fairly.
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, maxWidth: "600px", mx: "auto", color: "text.secondary" }}>
            You control both what you charge guests AND what you pay cleaners. 
            FreshSweeper only takes a small platform fee on completed bookings.
          </Typography>
          <Grid container spacing={3} sx={{ maxWidth: 800, mx: "auto" }}>
            <Grid item xs={4}>
              <Typography variant="h4" fontWeight="800" color="success.main">100%</Typography>
              <Typography variant="caption">Control over cleaner pay</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="h4" fontWeight="800" color="success.main">You Decide</Typography>
              <Typography variant="caption">Per property, per cleaner</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="h4" fontWeight="800" color="success.main">5%</Typography>
              <Typography variant="caption">Platform fee*</Typography>
            </Grid>
          </Grid>
          <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: "block" }}>
            * Only charged on completed bookings. No monthly fees or minimums.
          </Typography>
        </Paper>
      </Container>

      {/* Why This Matters Section */}
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: 3,
                height: "100%",
                border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                textAlign: "center",
              }}
            >
              <MonetizationOnIcon sx={{ fontSize: 48, color: theme.palette.primary.main, mb: 2 }} />
              <Typography variant="h6" fontWeight="800" gutterBottom>
                Attract Better Cleaners
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Pay above-market rates and get your pick of the best cleaners. They'll prioritize your properties.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: 3,
                height: "100%",
                border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                textAlign: "center",
              }}
            >
              <TrendingUpIcon sx={{ fontSize: 48, color: theme.palette.primary.main, mb: 2 }} />
              <Typography variant="h6" fontWeight="800" gutterBottom>
                Reduce Turnover
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Cleaners stay longer when they're paid fairly. Less training, more consistency.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: 3,
                height: "100%",
                border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                textAlign: "center",
              }}
            >
              <CheckCircleIcon sx={{ fontSize: 48, color: theme.palette.primary.main, mb: 2 }} />
              <Typography variant="h6" fontWeight="800" gutterBottom>
                Performance Incentives
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Offer bonuses for perfect 5-star reviews or last-minute availability. Motivate excellence.
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </FeatureLayout>
  );
};

export default SetYourPrice;